import { transformUrlField } from '../../../utils';
export default {
    name: 'UrlRender',
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: String,
            default: null,
        },
    },
    computed: {
        formattedValue() {
            return transformUrlField(this.value);
        },
    },
};
